module.exports = __webpack_public_path__ + "static/media/bg-volcano-desk.0df0ad15.svg";